import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconDownloadComponent } from "./med-icon-download.component";

@NgModule({
  declarations: [
    MedIconDownloadComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconDownloadComponent,
  ],
})
export class MedIconDownloadModule { }
